import React from 'react';

export function ActionTypeColumnFormatter(cellContent) {
  const {actionID, actionName} = cellContent;
  switch (actionID) {
    case 1:
      return (
        <div
          className="badge badge-pill w-100px font-size-h4 text-nowrap"
          style={{
            background: '#E3F0FB',
            border: '1px solid rgb(56, 189, 248)',
            color: 'rgb(56, 189, 248)'
          }}
        >
          {actionName}
        </div>
      );
    case 2:
      return (
        <div
          className="badge badge-pill w-100px font-size-h4 text-nowrap"
          style={{
            background: '#F9F4E5',
            border: '1px solid rgb(253, 185, 19)',
            color: 'rgb(253, 185, 19)'
          }}
        >
          {actionName}
        </div>
      );
    case 3:
      return (
        <div
          className="badge badge-pill w-100px font-size-h4 text-nowrap"
          style={{
            background: '#F2E6E6',
            border: '1px solid rgb(239, 65, 48)',
            color: 'rgb(239, 65, 48)',
          }}
        >
          {actionName}
        </div>
      );
    case 4:
      return (
        <div
          className="badge badge-pill w-100px font-size-h4 text-nowrap"
          style={{
            background: '#CDEADB',
            border: '1px solid rgb(65, 141, 88)',
            color: 'rgb(65, 141, 88)'
          }}
        >
          {actionName}
        </div>
      );
    default:
      return null;
  }
}